<section
    class="fluid-container mb-5 px-lg-6 p-md-4 p-3"
    style="background-color: #5ac3e1"
>
    <div
        class="d-flex flex-column flex-xl-row container gap-3 py-4"
        style="background-color: white; border-radius: 40px"
    >
        <div
            class="cta-image rounded"
            [ngStyle]="{
                'background-image':
                    'url(' + ('home-hero-banner-l' | cmsImageSrc | async) + ')',
            }"
        ></div>
        <div
            class="d-flex flex-column gap-3 gap-xl-4 gap-xxl-4 p-xl-3 p-xxl-4 text-center"
        >
            <div class="focus-text mx-xl-0 mx-auto">
                <div class="h6 text-center p-2 mb-3 hero-subtitle">
                    <span
                        [innerHTML]="
                            'hero-image-heading' | cmsText | jpText | async
                        "
                    >
                    </span>
                </div>
                <div class="h1">
                    <span
                        [innerHTML]="
                            'hero-image-text' | cmsText | jpText | async
                        "
                    ></span>
                </div>
                <div class="h2 d-none d-xl-block">
                    <span
                        [innerHTML]="
                            'hero-image-text-2' | cmsText | jpText | async
                        "
                    ></span>
                </div>
            </div>
            <div class="subtitle">
                <span
                    class="text-center"
                    [innerHTML]="
                        'hero-card-' +
                            (phaseService.getCmsAppendString$ | async) +
                            'text'
                            | cmsText
                            | jpText
                            | async
                    "
                >
                </span>
            </div>
            <div class="cta-button text-center">
                <button
                    *ngIf="this.registrationEnabled$ | async"
                    type="button"
                    aria-label="Register"
                    id="home-register-button-top"
                    [disabled]="
                        !(
                            registrationService.enableRegistrationFlow$ | async
                        ) ||
                        (isLoadingRegister && registerButtonClicked)
                    "
                    class="btn btn-primary btn-lg m-3 m-md-1"
                    (click)="registerButtonClicked = true"
                    [routerLink]="'../register'"
                    gaEvent
                    [gaPage]="{
                        path: this.communityService.communityCode + '/home',
                    }"
                    [gaActivity]="{
                        category: 'register-button',
                        action: 'click',
                    }"
                >
                    <i
                        *ngIf="isLoadingRegister && registerButtonClicked"
                        class="fa fa-spinner fa-spin me-1"
                    ></i>
                    <span
                        [innerHTML]="
                            'register-' +
                                (phaseService.getCmsAppendString$ | async) +
                                'button-text'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></span>
                    <i class="fa fa-chevron-right ms-2"></i>
                </button>
            </div>
            <div class="discount">
                <span
                    [innerHTML]="
                        'participant-count-text'
                            | cmsText
                                : [
                                      {
                                          participantCount:
                                              participantCount$
                                              | async
                                              | number: '' : 'ja-JP',
                                      },
                                  ]
                            | jpText
                            | async
                    "
                ></span>
            </div>
        </div>
    </div>
</section>

<section *ngIf="showDiscountRate$ | async">
    <div class="container">
        <div class="col-md-12 mx-auto mb-5">
            <div class="d-flex flex-lg-row flex-column justify-content-center">
                <div class="home-participant-icon w-lg-50 mx-3">
                    <img
                        class="img-fluid my-auto mt-lg-4 p-md-0 p-3"
                        [attr.src]="'group-logo' | cmsImageSrc | async"
                        [attr.alt]="'group-logo' | cmsImageAlt | async"
                    />
                </div>
                <div
                    class="w-md-85 my-auto text-md-left mx-3 col-lg-9 discount-block"
                >
                    <div class="discount-overview text-primary">
                        <div class="discount-overview__content">
                            <h5
                                class="discount-overview__summary h2"
                                [innerHTML]="
                                    'participant-count-summary'
                                        | cmsText
                                        | jpText
                                        | async
                                "
                            ></h5>
                        </div>
                    </div>
                    <div class="row row-cols-1 justify-content-between">
                        <div
                            *ngFor="
                                let item of discountRateItems;
                                let i = index
                            "
                            class="discount-item card col-12 col-md-3 mt-2"
                        >
                            <div class="discount-item__link-box">
                                <h6
                                    [innerHtml]="item.h6Key | cmsText | async"
                                ></h6>
                                <span class="discount-item__icon">
                                    <img
                                        [attr.src]="
                                            item.iconKey | cmsImageSrc | async
                                        "
                                        [attr.alt]="
                                            item.iconKey | cmsImageAlt | async
                                        "
                                    />
                                </span>
                                <span class="discount-item__kwh">
                                    <span
                                        class="discount-item__kwh__first"
                                        [innerHtml]="
                                            item.kwKey | cmsText | async
                                        "
                                    ></span>
                                    <span
                                        *ngIf="hasSecondKwItem(i) | async"
                                        class="discount-item__kwh__second"
                                        [innerHtml]="
                                            item.kwSecondKey | cmsText | async
                                        "
                                    ></span>
                                </span>
                                <span class="discount-item__discount">
                                    <span
                                        class="discount-item__discount__first"
                                        [innerHtml]="
                                            item.discountKey | cmsText | async
                                        "
                                    ></span>
                                    <span
                                        *ngIf="hasSecondDiscountItem(i) | async"
                                        class="discount-item__discount__second"
                                        [innerHtml]="
                                            item.discountSecondKey
                                                | cmsText
                                                | async
                                        "
                                    ></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row card bottom-note mt-3 p-2">
                        <div
                            [innerHTML]="
                                'participant-count-discount-rate-notice-text'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container bg-backdrop mb-5 py-5">
    <div class="container">
        <h3 class="mb-0 mb-md-5 mb-5 text-center">
            <span
                [innerHTML]="'home-group-buying-info-title' | cmsText | async"
            ></span>
        </h3>
        <div class="row">
            <div class="col-lg-7 col-12 my-lg-auto my-3">
                <div
                    [innerHTML]="
                        'home-group-buying-info-text' | cmsText | jpText | async
                    "
                ></div>
            </div>
            <div
                class="col-lg-5 col border-width-2 border-dashed p-3 m-3 my-lg-auto mx-lg-0"
            >
                <h6
                    [innerHTML]="
                        'home-group-buying-info-list-title'
                            | cmsText
                            | jpText
                            | async
                    "
                ></h6>
                <ol class="ps-4 m-0">
                    <li
                        [innerHTML]="
                            'home-group-buying-info-list-line-1'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                    <li
                        [innerHTML]="
                            'home-group-buying-info-list-line-2'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                    <li
                        [innerHTML]="
                            'home-group-buying-info-list-line-3'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                    <li
                        [innerHTML]="
                            'home-group-buying-info-list-line-4'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></li>
                </ol>
            </div>
        </div>
    </div>
</section>

<div class="fluid-container">
    <div class="container pb-md-5 pt-md-4">
        <h3 class="mb-0 mb-md-5 mb-5 text-center">
            <span [innerHTML]="'home-link-box-title' | cmsText | async"></span>
        </h3>
        <div class="row row-cols-1 pb-md-4 pt-md-5 justify-content-between">
            <div
                *ngFor="let itemNumber of [1, 2, 3]"
                class="card link-box col-md-3 col-12 my-md-0 my-5 hoverable"
            >
                <a
                    [routerLink]="
                        formatBulletLink('hero-bullet-' + itemNumber + '-link')
                            | async
                    "
                >
                    <div
                        class="col-xl-5 col-lg-6 col-md-8 col-sm-10 col-5 mx-auto card-icon"
                    >
                        <app-shadow-dom-encapsulate>
                            <div class="link-box-icon-border">
                                <svg-icon
                                    [svgClass]="'rounded-circle img-fluid link-box-icon svg-colors'"
                                    [src]="
                                        'hero-bullet-' + itemNumber + '-img'
                                            | cmsImageSrc
                                            | async
                                    "
                                    [svgAriaLabel]="
                                        'hero-bullet-' + itemNumber + '-img'
                                            | cmsImageAlt
                                            | async
                                    "
                                ></svg-icon>
                            </div>
                        </app-shadow-dom-encapsulate>
                    </div>
                    <div class="pt-2 pb-4 px-md-2">
                        <i class="fa fa-chevron-right float-end"></i>
                        <h3
                            class="card-title h6 fw-bold link-box-title text-md-center mt-3"
                            [innerHTML]="
                                'hero-bullet-' + itemNumber + '-title'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></h3>
                        <p
                            class="card-text link-box-text"
                            [innerHTML]="
                                'hero-bullet-' + itemNumber + '-text'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<section *ngIf="!isB2B" class="fluid-container bg-backdrop py-5">
    <div *ngIf="interestedIndividualEnabled">
        <app-webinar-interested-individuals></app-webinar-interested-individuals>
    </div>
    <div *ngIf="!interestedIndividualEnabled">
        <app-webinar-full-registration></app-webinar-full-registration>
    </div>
</section>

<ng-container
    *ngIf="
        showBatteryDetails && contentService.valueExists('home-battery-title')
            | async
    "
>
    <section class="fluid-container my-5 py-5">
        <div class="container">
            <div class="row">
                <div class="col-md-5 p-3">
                    <app-shadow-dom-encapsulate>
                        <svg-icon
                            [svgClass]="'img-fluid svg-colors'"
                            [src]="'home-battery-image' | cmsImageSrc | async"
                            [svgAriaLabel]="
                                'home-battery-image' | cmsImageAlt | async
                            "
                        ></svg-icon>
                    </app-shadow-dom-encapsulate>
                </div>
                <div
                    class="col-md-7 bg-white rounded p-4 text-center ms-auto me-auto"
                >
                    <div *ngIf="!isB2B">
                        <h3 class="mb-4">
                            {{
                                'home-battery-title' | cmsText | jpText | async
                            }}
                        </h3>
                        <div class="text-start lead">
                            <ol>
                                <li
                                    [innerHTML]="
                                        'home-battery-1-text'
                                            | cmsText
                                            | jpText
                                            | async
                                    "
                                ></li>
                                <li
                                    [innerHTML]="
                                        'home-battery-2-text'
                                            | cmsText
                                            | jpText
                                            | async
                                    "
                                ></li>
                                <li
                                    *ngIf="
                                        contentService.valueExists(
                                            'home-battery-3-text'
                                        ) | async
                                    "
                                    [innerHTML]="
                                        'home-battery-3-text'
                                            | cmsText
                                            | jpText
                                            | async
                                    "
                                ></li>
                            </ol>
                        </div>
                        <div
                            class="text-start lead d-block d-sm-none"
                            *ngIf="
                                contentService.valueExists(
                                    'home-battery-details-text-sm'
                                ) | async
                            "
                            [innerHTML]="
                                'home-battery-details-text-sm'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>

                        <div
                            class="text-start lead d-none d-sm-block"
                            *ngIf="
                                contentService.valueExists(
                                    'home-battery-details-text'
                                ) | async
                            "
                            [innerHTML]="
                                'home-battery-details-text'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>
                    </div>
                    <div *ngIf="isB2B">
                        <div
                            class="mb-4"
                            [innerHTML]="
                                'home-battery-title-b2b'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>
                        <div
                            class="text-start lead"
                            [innerHTML]="
                                'home-battery-text-b2b'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>
                        <div
                            class="text-start lead"
                            *ngIf="
                                contentService.valueExists(
                                    'home-battery-details-text'
                                ) | async
                            "
                            [innerHTML]="
                                'home-battery-details-text'
                                    | cmsText
                                    | jpText
                                    | async
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</ng-container>

<section
    *ngIf="contentService.valueExists('home-quote-text') | async"
    class="fluid-container my-5 py-5 bg-backdrop"
>
    <div class="container">
        <hr *ngIf="!showBatteryDetails" class="my-5" />
        <div class="row">
            <div class="col-6 col-lg-3 mx-auto">
                <img
                    class="rounded-circle img-fluid"
                    [attr.alt]="'home-governor-image' | cmsImageAlt | async"
                    [attr.src]="'home-governor-image' | cmsImageSrc | async"
                />
            </div>
            <div class="col-12 col-lg-7 my-auto pt-lg-0 pt-3">
                <div
                    class="lead"
                    [innerHTML]="'home-quote-text' | cmsText | jpText | async"
                ></div>
                <span
                    class="text-muted text-end"
                    *ngIf="
                        contentService.valueExists('home-quote-footer') | async
                    "
                    [innerHTML]="'home-quote-footer' | cmsText | jpText | async"
                >
                </span>
            </div>
        </div>
    </div>
</section>

<section
    *ngIf="contentService.valueExists('home-quote-text-2') | async"
    class="fluid-container my-5 py-5 bg-backdrop"
>
    <div class="container">
        <div class="row">
            <div class="col-3 col-lg-2 mx-auto me-lg-4">
                <img
                    class="rounded-circle img-fluid"
                    [attr.alt]="'home-quote-image' | cmsImageAlt | async"
                    [attr.src]="'home-quote-image' | cmsImageSrc | async"
                />
            </div>
            <div class="col-3 col-lg-2 mx-auto me-lg-5">
                <img
                    class="rounded-circle img-fluid"
                    [attr.alt]="'home-quote-image-2' | cmsImageAlt | async"
                    [attr.src]="'home-quote-image-2' | cmsImageSrc | async"
                />
            </div>
            <div class="col-12 col-lg-7 my-auto pt-lg-0 pt-3">
                <div
                    class="lead"
                    [innerHTML]="'home-quote-text-2' | cmsText | jpText | async"
                ></div>
                <span
                    class="text-muted text-end"
                    *ngIf="
                        contentService.valueExists('home-quote-footer') | async
                    "
                    [innerHTML]="'home-quote-footer' | cmsText | jpText | async"
                >
                </span>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container my-5 py-5">
    <div class="container">
        <div [ngClass]="{ row: true, 'bg-white': showVideo$ | async }">
            <div class="col-md-5 p-3" *ngIf="showVideo$ | async">
                <div
                    class="embed-responsive rounded ratio ratio-16x9"
                    [youtubemovie]="'home-page-youtube-video' | cmsText | async"
                ></div>
            </div>
            <div
                [ngClass]="{
                    'col-md-7': showVideo$ | async,
                    'col-md-8': !(showVideo$ | async),
                    'bg-white': true,
                    rounded: true,
                    'p-4': true,
                    'text-center': true,
                    'ms-auto': true,
                    'me-auto': true,
                }"
            >
                <h3 class="mb-4">
                    {{ 'why-signup-title' | cmsText | jpText | async }}
                </h3>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="mb-3 text-start"
                        [innerHTML]="
                            'why-signup-bullet-1-md' | cmsText | jpText | async
                        "
                    ></div>
                </div>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="mb-3 text-start"
                        [innerHTML]="
                            'why-signup-bullet-2-' +
                                (phaseService.getCmsAppendString$ | async) +
                                'md'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></div>
                </div>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="mb-3 text-start"
                        [innerHTML]="
                            'why-signup-bullet-3-' +
                                (phaseService.getCmsAppendString$ | async) +
                                'md'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></div>
                </div>
                <div class="d-flex align-items-start">
                    <div
                        *ngIf="!(showVideo$ | async)"
                        class="col-1 col-lg-2 d-md-block d-none"
                    ></div>
                    <i class="text-primary fa fa-check me-2 mt-2 fa-lg"></i>
                    <div
                        class="mb-3 text-start"
                        [innerHTML]="
                            'why-signup-bullet-4-md' | cmsText | jpText | async
                        "
                    ></div>
                </div>
                <a
                    [routerLink]="'../info/group-buying-merits'"
                    id="home-info-merits-button"
                    class="btn btn-outline-primary mx-auto px-5 my-3"
                >
                    {{ 'group-buying-merits-info-button-text' | cmsText | async
                    }}<i class="fa fa-chevron-right ms-2"></i>
                </a>
            </div>
        </div>
    </div>
</section>

<section
    class="fluid-container text-start text-lg-center py-5 mt-5 bg-backdrop"
>
    <div class="container">
        <h3 class="mb-0 mb-md-5 mb-5">
            <span [innerHTML]="'how-it-works-title' | cmsText | async"></span>
        </h3>
        <div class="d-flex justify-content-between row">
            <div
                *ngFor="let item of [1, 2, 3, 4, 5]"
                class="col-md-2 col-12 my-3 my-md-0"
            >
                <div
                    class="row"
                    *ngIf="
                        contentHelperService.getFullKeyNameIfExists(
                            'how-it-works-bullet-' + item + '-title'
                        ) | async as cmsKey
                    "
                >
                    <div
                        class="col-md-8 col-3 mx-auto rounded-circle how-it-works bg-white p-3"
                    >
                        <app-shadow-dom-encapsulate>
                            <svg-icon
                                [svgClass]="'img-fluid svg-colors'"
                                [src]="
                                    'how-it-works-bullet-' + item + '-img'
                                        | cmsImageSrc
                                        | async
                                "
                                [svgAriaLabel]="
                                    'how-it-works-bullet-' + item + '-img'
                                        | cmsImageAlt
                                        | async
                                "
                            ></svg-icon>
                        </app-shadow-dom-encapsulate>
                    </div>

                    <div class="col-md-12 col-9 my-auto">
                        <h3 class="h6 fw-bold mt-0 mt-md-3">
                            <span
                                [innerHTML]="cmsKey | cmsText | jpText | async"
                            ></span>
                        </h3>
                        <p>
                            <span
                                [innerHTML]="
                                    contentHelperService.getFullKeyNameIfExists(
                                        'how-it-works-bullet-' + item + '-text'
                                    )
                                        | async
                                        | cmsText
                                        | async
                                "
                            ></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-5 text-center">
            <a
                [routerLink]="'../info/how-does-it-work'"
                id="home-info-how-works-button"
                class="btn btn-outline-primary text-uppercase ms-auto me-auto px-5"
            >
                {{ 'more-info-button-text' | cmsText | async
                }}<i class="fa fa-chevron-right ms-2"></i>
            </a>
        </div>
    </div>
</section>

<section
    *ngIf="this.registrationEnabled$ | async"
    class="fluid-container mb-5 py-5 bg-primary"
>
    <div class="container text-white text-center">
        <h2
            class="px-4"
            [innerHTML]="
                'info-register-' +
                    (phaseService.getCmsAppendString$ | async) +
                    'header'
                    | cmsText
                    | jpText
                    | async
            "
        ></h2>
        <div class="button-wrapper btn-container-center">
            <button
                type="button"
                aria-label="Register"
                class="btn btn-light btn-lg text-uppercase px-5 m-3 m-md-1"
                id="home-register-button-bottom"
                [disabled]="
                    !(registrationService.enableRegistrationFlow$ | async) ||
                    (isLoadingRegister && registerButtonClicked)
                "
                [routerLink]="'../register'"
                (click)="registerButtonClicked = true"
                gaEvent
                [gaPage]="{
                    path: this.communityService.communityCode + '/home',
                }"
                [gaActivity]="{ category: 'register-button', action: 'click' }"
            >
                <i
                    *ngIf="isLoadingRegister && registerButtonClicked"
                    class="fa fa-spinner fa-spin me-1"
                ></i>
                <span
                    [innerHTML]="
                        'register-' +
                            (phaseService.getCmsAppendString$ | async) +
                            'button-text'
                            | cmsText
                            | jpText
                            | async
                    "
                ></span>
                <i class="fa fa-chevron-right ms-2"></i>
            </button>
        </div>
    </div>
</section>

<div class="py-3">
    <app-socialnetwork-icons></app-socialnetwork-icons>
</div>
